module.exports = __webpack_public_path__ + "img/nxlb.0f798cf7.jpg";